import { render, staticRenderFns } from "./Empresas.vue?vue&type=template&id=2269cae7&scoped=true"
import script from "./Empresas.vue?vue&type=script&lang=js"
export * from "./Empresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269cae7",
  null
  
)

export default component.exports